import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "infoSummary",
  "use": "infoSummary-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\" id=\"infoSummary\">\n<path d=\"M10,0C4.5,0,0,4.5,0,10s4.5,10,10,10s10-4.5,10-10S15.5,0,10,0z M10,15L10,15c-0.6,0-1-0.4-1-1v-4c0-0.6,0.4-1,1-1l0,0\n\tc0.6,0,1,0.4,1,1v4C11,14.6,10.6,15,10,15z M10.5,7h-1C9.2,7,9,6.8,9,6.5v-1C9,5.2,9.2,5,9.5,5h1C10.8,5,11,5.2,11,5.5v1\n\tC11,6.8,10.8,7,10.5,7z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol